module.exports = __webpack_public_path__ + "img/farm.23142e7d.svg";